<template>
    <div id="contentcontainer" class="standard-mode">
        <v-snackbar top v-model="notification.show" :color="notification.color">
            <v-icon>{{ notification.icon }}</v-icon>
            <span class="font-weight-bold pl-2"> {{ notification.message }} </span>
        </v-snackbar>
        <div v-if="!project.created">
            <div class="monitoringstepper mt-10 mb-7 pl-1" style="color: #717171">
                <div style="font-size: 24px; text-transform: uppercase">
                    <span>New AI Tracking Project</span>
                </div>
                <div style="font-size: 12px">Set basic settings like title, brand, and tracking options</div>
            </div>
        </div>
        <!-- <v-slide-x-transition v-else>
            <div class="mt-10 mb-7 monitoringstepper pl-1">
                <div style="font-size: 12px; text-transform: uppercase">New AI Tracking Project</div>
                <div style="font-size: 24px" class="pb-1">
                    <span>{{ project.title }}</span>
                </div>
                <div style="font-size: 12px">
                    <v-chip color="primary" class="mr-2" style="text-transform: capitalize">
                        <v-icon small class="mr-1">mdi-tag</v-icon>
                        {{ project.brand }}
                    </v-chip>
                    <v-chip color="primary" class="mr-2" style="text-transform: capitalize">
                        <v-icon small class="mr-1">mdi-robot</v-icon>
                        {{ project.tracking.model }}
                    </v-chip>
                    <v-chip color="primary" class="mr-2" style="text-transform: capitalize">
                        <v-icon small class="mr-1">mdi-calendar-clock</v-icon>
                        {{ project.tracking.frequency }}
                    </v-chip>
                    <v-chip v-if="project.tracking.region" color="primary" class="mr-2" style="text-transform: capitalize">
                        <v-icon small class="mr-1">mdi-map-marker</v-icon>
                        {{ project.tracking.region }}
                    </v-chip>
                </div>
            </div>
        </v-slide-x-transition> -->

        <v-stepper color="white" rounded v-model="e1" alt-labels non-linear class="rounded_card quaroshadow monitoringstepper mb-10" id="ai-setup">
            <v-stepper-header elevation-0>
                <v-stepper-step :complete="e1 > 1" step="1">Project Data</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2">Add Prompts</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <!-- Step 1: Project Data -->
                <v-stepper-content step="1">
                    <CreateProject :project="project"></CreateProject>
                    <v-row no-gutters class="mt-3">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="nextStep">Continue</v-btn>
                    </v-row>
                </v-stepper-content>

                <!-- Step 2: Tracking Options -->
                <v-stepper-content step="2" class="px-0 pt-0">
                    <AddPrompts :project="project" mountedOn="llm_setup" @createNotification="createNotification" @promptsAdded="promptsAdded" @promptsAddedDetailed="promptsAddedDetailed" />
                    <v-row no-gutters class="mt-3 px-5">
                        <v-btn text absolute style="bottom: 30px" class="mr-auto" @click="e1--">Back</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn rounded color="primary" @click="createProjectWithTracking">Create Project</v-btn>
                    </v-row>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>
</template>

<script>
    import CreateProject from "@/components/aisuite/CreateProject.vue"
    import AddPrompts from "@/components/aisuite/AddPrompts.vue"
    export default {
        components: { CreateProject, AddPrompts },
        data() {
            return {
                e1: 1,
                notification: { show: false },
                prompts: [], // hinzugefügt
                promptObjects: [], // NEU: detaillierte Prompts (mit Tags falls vorhanden)
                project: {
                    title: "",
                    device: "mobile",
                    platforms: ["chatgpt", "gemini", "perplexity", "google", "google_ai_mode", "microsoft_copilot"],
                    brand: { brand_name: "", brand_domain: "" },
                    langloc: { location_text: "Germany", country_code: "DE", language_code: "de", location_code: 2276, google_ai_mode_enabled: true },
                    domain: "",
                    setup: {
                        finished: false
                    },
                    status: {
                        serp_refetch: true,
                        serp_update: true,
                        ai_refetch: true,
                        ai_update: true
                    },
                    created: false,
                    load_async_ai_overview: true,
                    categorized_project: false,
                    interval: 1,
                    type: "ai_tracking",
                    google: false,
                    environment: process.env.VUE_APP_ENVIRONMENT == "dev" || process.env.VUE_APP_ENVIRONMENT == "local" ? "dev" : "prod",
                    serp_depth: 10
                }
            }
        },
        methods: {
            promptsAdded(prompts) {
                this.project.prompt_count = prompts.length
                this.prompts = prompts // weiter Strings für Backward-Kompatibilität
            },
            promptsAddedDetailed(objs) {
                this.promptObjects = Array.isArray(objs) ? objs : []
            },
            createNotification(message, icon, color) {
                this.notification = this.$helpers.createNotification(message, icon, color)
            },
            async nextStep() {
                if (!this.project.title || this.project.title.length < 3) {
                    this.createNotification("Please provide a project title with at least 3 characters!", "mdi-alert", "orange darken-2")
                    return
                }
                if (!this.project.brand.brand_name || this.project.brand.brand_name.length < 2) {
                    this.createNotification("Please provide a brand!", "mdi-alert", "orange darken-2")
                    return
                }
                this.e1++
            },
            async createProjectWithTracking() {
                try {
                    if (!this.prompts.length) {
                        this.createNotification("Please add at least one prompt to the project!", "mdi-alert", "orange darken-2")
                        return
                    }
                    const tooLongCount = this.prompts.filter((p) => (p || "").length > 700).length
                    if (tooLongCount) {
                        this.createNotification(`${tooLongCount} prompt(s) exceed 700 characters. Please shorten them before creating the project.`, "mdi-alert", "orange darken-2")
                        return
                    }
                    // Optionally set createdBy here
                    console.log("Project data:", this.project)
                    this.project.createdBy = localStorage.user_id
                    this.project.domain = this.project.brand.brand_domain
                    this.project.created = true
                    this.project.created_date = new Date()
                    this.project.categorized_project = this.promptObjects.some((p) => p.tags && p.tags.length > 0)
                    // API call to create the project
                    console.log("promptObject with tags:", this.promptObjects[0])
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/add/keywords"
                    const post_data = {
                        company_id: localStorage.company_id,
                        project: this.project,
                        keywords: this.project.categorized_project ? this.promptObjects : this.prompts, // unverändert (Strings)
                        // prompt_meta: this.promptObjects, // NEU (Backend ignoriert falls nicht implementiert)
                        socket_id: this.$socket.id
                    }
                    console.log(post_data)
                    let response_data = await this.$helpers.axiosPost(url, post_data)
                    console.log(response_data)
                    if (response_data.data.created == false) {
                        console.log("created notification")
                        this.createNotification("A project with this title already exists!", "mdi-alert", "orange darken-2")
                        return
                    }
                    if (response_data.data.error == "not_enough_credits") {
                        this.createNotification(
                            "You do not have enough credits left. Requested prompt updates: " +
                                (this.project.interval == 28 ? 1 : this.project.interval == 7 ? 4 : 30) * post_data.keywords.length * this.project.platforms.length +
                                ". Remaining prompt updates: " +
                                (response_data.data.credits - response_data.data.count),
                            "mdi-alert-circle-outline",
                            "#FCBA03"
                        )

                        return
                    }
                    this.$router.push("/ai-suite")
                } catch (error) {
                    this.createNotification("Error creating the project. Please try again!", "mdi-alert", "orange darken-2")
                    await this.notifyAdminError(error, {
                        source: "AISuite.Setup.createProjectWithTracking",
                        project_title: this.project && this.project.title ? this.project.title : null,
                        prompt_count: Array.isArray(this.prompts) ? this.prompts.length : 0,
                        categorized_project: !!(this.project && this.project.categorized_project)
                    })
                }
            },
            async notifyAdminError(e, contextData, responseData) {
                let errorPayload
                try {
                    errorPayload = {
                        type: "Error",
                        data: {
                            message: e?.message || String(e),
                            stack: e?.stack || null,
                            response: e?.response
                                ? {
                                      status: e.response.status,
                                      data: typeof e.response.data === "object" ? JSON.stringify(e.response.data) : String(e.response.data)
                                  }
                                : undefined,
                            context: {
                                ...(contextData || {}),
                                user_id: localStorage.id || localStorage.user_id,
                                company_id: localStorage.company_id
                            },
                            responseData: responseData ? (typeof responseData === "object" ? JSON.stringify(responseData) : String(responseData)) : undefined
                        },
                        user: localStorage.username,
                        company_id: localStorage.company_id
                    }

                    await this.$helpers.axiosPost(process.env.VUE_APP_APIURL + "/service/notify/admin", errorPayload)
                } catch (notifyErr) {
                    try {
                        await this.$helpers.axiosPost(process.env.VUE_APP_APIURL + "/service/notify/admin", {
                            type: "Error",
                            data: {
                                message: "Error notification failed",
                                originalError: e && e.message ? e.message : String(e),
                                notifyError: notifyErr && notifyErr.message ? notifyErr.message : String(notifyErr)
                            },
                            user: localStorage.username || "-",
                            company_id: localStorage.company_id || "-"
                        })
                    } catch {
                        console.log("Admin notification failed completely", notifyErr)
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .monitoringstepper {
        max-width: 800px;
        margin: auto;
    }
    .v-stepper__header {
        box-shadow: 0px 3px 12px var(--v-shadow1-base), 3px 0px 12px var(--v-shadow2-base) !important;
    }
    #ai-setup .v-stepper__step--active {
        background-color: #17807170 !important;
    }
    #ai-setup .v-stepper__step--active .v-stepper__step__step {
        background-color: white !important;
        color: var(--v-primary-base) !important;
    }
    #ai-setup .v-stepper__step__step {
        background-color: white !important;
        color: var(--v-primary-base) !important;
    }
    #ai-setup .v-stepper__header {
        background-color: var(--v-primary-base);
        color: white !important;
    }
    #ai-setup .v-stepper__label {
        color: white !important;
        font-weight: bold;
        font-size: 18px;
    }
</style>
